export default __webpack_public_path__ + "static/media/thumb_15.a3de2ee9.webp";